import { Type } from '@hugendubel/ws_client';
import { WsBaseAddress } from './WsBaseAddress';
import { WsAddress } from './WsAddress';
import { WsPackstation } from './WsPackstation';

export class WsAddressList {
    items: Array<WsBaseAddress>;

    constructor(items: Array<WsBaseAddress>) {
        this.items = items;
    }

    static fromApi(json: any): WsAddressList {
        return new WsAddressList(
            Type.array(json.items, 'AddressList.items').map(address =>
                Type.boolean(address.packstation, 'AddressList.packstation')
                    ? WsPackstation.fromApi(address)
                    : WsAddress.fromApi(address)
            )
        );
    }
}
